/* Aviso de compra reciente ("Byron desde Quetzaltenango compró..."). Adaptado tal cual
   del mecanismo ya probado en Liver Support (lv-pop.js): mismo comportamiento, nombres
   masculinos porque el producto es de barba.

   - Aparece a los 9 s, no de entrada: primero que lea el gancho de la lamina 01.
   - 6 avisos como maximo y se calla. Un bucle infinito compite con el CTA y cansa.
   - Se cierra con la x y no vuelve en toda la sesion (se recuerda en sessionStorage).
   - Se coloca por encima del boton COD fijo de Releasit para no taparlo.
   - Respeta prefers-reduced-motion y se pausa si la pestana no esta visible. */
(function () {
  if (window.__baPop) return;
  window.__baPop = 1;

  var yo = document.currentScript;
  var PRODUCTO = (yo && yo.dataset.producto) || 'Bálsamo Apolo';
  var FOTO = (yo && yo.dataset.foto) || '';

  var GENTE = [
    ['Byron', 'Quetzaltenango'], ['Luis Fernando', 'Escuintla'], ['Mynor', 'Cobán'],
    ['Edwin', 'Chimaltenango'], ['Walter', 'Mazatenango'], ['Douglas', 'Retalhuleu'],
    ['Estuardo', 'Sololá'], ['Otoniel', 'Chiquimula'], ['Rodrigo', 'Santa Lucía Cotzumalguapa'],
    ['Marco Tulio', 'Ciudad de Guatemala'], ['Selvin', 'Huehuetenango'], ['Josué', 'Mixco'],
    ['Brandon', 'Villa Nueva'], ['Fredy', 'Jalapa'], ['Hugo', 'Zacapa'],
    ['Erick', 'Puerto Barrios'], ['Cristian', 'Petén'], ['Gerson', 'Antigua Guatemala']
  ];

  var CSS =
    '.ba-pop{position:fixed;left:12px;bottom:104px;z-index:99999;display:flex;' +
    'align-items:center;gap:11px;max-width:min(330px,calc(100vw - 24px));' +
    'padding:10px 34px 10px 10px;border-radius:14px;background:#fff;color:#161410;' +
    'box-shadow:0 10px 30px rgba(0,0,0,.28);font-family:inherit;' +
    'transform:translateY(14px);opacity:0;pointer-events:none;' +
    'transition:opacity .35s ease,transform .35s ease}' +
    '.ba-pop.on{opacity:1;transform:translateY(0);pointer-events:auto}' +
    '.ba-pop img{width:46px;height:46px;object-fit:cover;border-radius:9px;' +
    'flex:0 0 auto;background:#EFEAE0}' +
    '.ba-pop b{font-weight:700}' +
    '.ba-pop__t{font-size:13px;line-height:1.35}' +
    '.ba-pop__h{display:block;margin-top:3px;font-size:11px;color:#8A8168}' +
    '.ba-pop__x{position:absolute;top:6px;right:8px;border:0;background:none;' +
    'font-size:17px;line-height:1;color:#B0A98F;cursor:pointer;padding:2px 4px}' +
    '@media(prefers-reduced-motion:reduce){.ba-pop{transition:none}}';

  function init() {
    if (sessionStorage.getItem('baPopCerrado') === '1') return;

    var st = document.createElement('style');
    st.textContent = CSS;
    document.head.appendChild(st);

    var caja = document.createElement('div');
    caja.className = 'ba-pop';
    caja.setAttribute('role', 'status');
    caja.innerHTML =
      (FOTO ? '<img src="' + FOTO + '" alt="" width="46" height="46">' : '') +
      '<div class="ba-pop__t"></div>' +
      '<button class="ba-pop__x" type="button" aria-label="Cerrar aviso">&times;</button>';
    document.body.appendChild(caja);

    var texto = caja.querySelector('.ba-pop__t');
    var muerto = false;

    caja.querySelector('.ba-pop__x').addEventListener('click', function () {
      muerto = true;
      caja.classList.remove('on');
      try { sessionStorage.setItem('baPopCerrado', '1'); } catch (e) {}
    });

    var vistos = [];
    function siguiente() {
      var i;
      do { i = Math.floor(Math.random() * GENTE.length); } while (vistos.indexOf(i) > -1);
      vistos.push(i);
      if (vistos.length > GENTE.length - 3) vistos = [];
      var minutos = 2 + Math.floor(Math.random() * 26);
      texto.innerHTML =
        '<b>' + GENTE[i][0] + '</b> desde <b>' + GENTE[i][1] + '</b><br>' +
        'compró 1 ' + PRODUCTO +
        '<span class="ba-pop__h">hace ' + minutos + ' minutos</span>';
    }

    var vueltas = 0;
    function ciclo() {
      if (muerto || vueltas >= 6) return;
      if (document.hidden) { setTimeout(ciclo, 6000); return; }
      vueltas++;
      siguiente();
      caja.classList.add('on');
      setTimeout(function () {
        caja.classList.remove('on');
        setTimeout(ciclo, 18000 + Math.floor(Math.random() * 14000));
      }, 6000);
    }
    setTimeout(ciclo, 9000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
